// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getReorderPad, ReorderPadApiParameter, ReorderPadModel } from "@steiner/App/Services/ReorderPad";

type HandlerType = ApiHandler<ReorderPadApiParameter & HasOnSuccess, ReorderPadModel>;

export const defaultReorderPadParameters = {
    customerPartNumber: "",
    customerSequence: "-1",
    fromDate: "",
    mfgrNumber: "",
    page: 1,
    pageSize: 16,
    productDescription: "",
    sortBy: "",
    toDate: "",
};

export const DispatchBeginLoadReorderPad: HandlerType = props => {
    props.dispatch({
        type: "xReorderPad/BeginLoadingReorderPad",
        isLoading: true,
    } as any);
};

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiParameter.customerSequence = props.apiParameter?.customerSequence === "-2" ? "-1" : props.apiParameter?.customerSequence;
        props.apiResult = await getReorderPad(props.apiParameter);
    } catch (error) {
        props.dispatch({
            type: "xReorderPad/FailedLoadingReorderPad",
        } as any);

        return false;
    }
};

export const DispatchCompleteLoadReorderPadItems: HandlerType = props => {
    props.dispatch({
        type: "xReorderPad/CompleteLoadingReorderPad",
        value: props.apiResult,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchBeginLoadReorderPad,
    PopulateApiParameters,
    RequestDataFromApi,
    DispatchCompleteLoadReorderPadItems,
];

const loadReorderPad = createHandlerChainRunnerOptionalParameter(chain, defaultReorderPadParameters, "loadReorderPad");

export default loadReorderPad;
